export default __webpack_public_path__ + "static/media/279.b2e818ad.png";